import Enum from "./Enum";

export default Enum.create( {
	TEAM: "TEAM",
	ONE_ON_ONE: "ONE_ON_ONE",
} );
